export enum RowColors {
  LOCKED = "#C8C5BC",
  RELEASED = "#FFEDC8",
  FINISHED = "#D5EDC2",
}

export interface RowOptions {
  cellNames: string[];
  cellNametoLinks: Map<string, string>;
  autoReleaseDate?: string;
  dueDate?: string;
  backgroundColor?: string;
  /** Set when the row's content has not been released yet. */
  locked?: boolean;
  /** The assignment students should be working on right now. */
  current?: boolean;
}

export interface CourseTable {
  header: string[];
  rows: RowOptions[];
}
